/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {shareReceipt} from '../api'

export const useMutationShareReceipt = createReactQueryMutationHook('shareReceipt', shareReceipt)
